<template>
  <div>
    <Button
      style="margin-bottom: 20px;"
      type="primary"
      @click="addDataColumnAuthOpeationBtnClick"
      >操作录入</Button
    >
    <Table
      class="dataAuthTable"
      border
      :columns="dataColumnAuthColumns"
      size="small"
      stripe
      :data="dataColumnAuthDataSource"
      disabled-hover
      row-key="id"
      ref="dataAuthtableRef"
    >
    </Table>
    <div style="margin: 10px; overflow: hidden">
      <div style="float: right">
        <Page
          show-total
          show-sizer
          :total="dataColumnAuthCount"
          :current="columnFilter.pageIndex"
          :page-size="columnFilter.pageSize"
          :page-size-opts="[5, 10, 15, 20]"
          @on-change="dataColumnChangePage"
          @on-page-size-change="dataColumnSizeChange"
        ></Page>
      </div>
    </div>
    <!-- 数据列权限表单 -->
    <Modal v-model="dataColumnAuthFormDisplayStatus" title="操作录入">
      <Form
        label-position="left"
        :label-width="100"
        :model="dataColumnAuthValidate"
        ref="dataColumnAuthValidate"
        :rules="dataColumnAuthRuleValidate"
      >
        <FormItem label="规则名称:" prop="ruleName">
          <Input
            placeholder="请输入规则名称"
            v-model="dataColumnAuthValidate.ruleName"
          ></Input>
        </FormItem>
        <FormItem label="展示列:" prop="ruleOrigJson">
          <Input
            placeholder="展示列,多个列名逗号分隔"
            v-model="dataColumnAuthValidate.ruleOrigJson"
          ></Input>
        </FormItem>
        <FormItem label="表名称:" prop="tableName">
          <Input
            placeholder="请输入表名称"
            v-model="dataColumnAuthValidate.tableName"
          ></Input>
        </FormItem>
        <FormItem>
          <Button
            type="primary"
            @click="dataColumnHandleSubmit('dataColumnAuthValidate')"
            >确认</Button
          >
          <Button @click="popDataRowMoal" style="margin-left: 8px">取消</Button>
        </FormItem>
      </Form>
      <template #footer>
        <div style="height: 0px;"></div>
      </template>
    </Modal>
  </div>
</template>
<script>
import { mapActions, mapMutations, mapState } from 'vuex';
// import getPermissionMixin from '@/mixins/getPermissionMixin';
import ykRule from '@/assets/js/ykRule';
import { getDataColumnAuthColumns } from '../config';

const addColunmRuleURL = '/v1/funcMenu/dataColRule';
export default {
  props: {
    selectedMenuObj: {
      type: Object,
      default: {}
    },
    currentSystem: {
      type: String,
      default: ''
    }
  },
  // mixins: [getPermissionMixin],
  watch: {
    selectedMenuObj: {
      deep: true,
      handler(newValue, oldValue) {
        this.refreshDataColumnAuthData();
      }
    }
  },
  computed: {
    ...mapState('menuManage', [
      'dataColumnAuthDataSource',
      'dataColumnAuthCount'
    ])
  },
  data() {
    return {
      colunmOpterate: 0,
      currentOpreateObj: '',
      columnFilter: {
        pageIndex: 1,
        pageSize: 10
      },
      dataColumnAuthRuleValidate: {
        ruleName: [
          { required: true, message: '规则名称未填写', trigger: 'blur' }
        ],
        ruleOrigJson: [
          { required: true, message: '展示列未填写', trigger: 'blur' }
        ],
        tableName: [
          { required: false, message: '表名称未填写', trigger: 'blur' }
        ]
      },
      dataColumnAuthValidate: {
        appId: '',
        funcMenuId: '',
        ruleName: '',
        ruleOrigJson: '',
        tableName: ''
      },
      dataColumnAuthFormDisplayStatus: false,
      dataColumnAuthColumns: getDataColumnAuthColumns(
        this.deleteDataColumAuthBtnClick,
        this.editDataColumAuthBtnClickBtnClick
      )
    };
  },
  methods: {
    ...mapMutations('menuManage', ['SAVE_STATE']),
    ...mapActions('menuManage', ['getUserPermission', 'getDataColumnAuthList']),

    dataColumnChangePage(num) {
      this.columnFilter.pageIndex = num;
      this.getDataColumnAuthList({
        funcMenuId: this.selectedMenuObj.id,
        columnFilter: this.columnFilter
      });
    },
    clearDataColumnValidate() {
      this.dataColumnAuthValidate.funcMenuId = '';
      this.dataColumnAuthValidate.ruleName = '';
      this.dataColumnAuthValidate.ruleOrigJson = '';
      this.dataColumnAuthValidate.tableName = '';
    },
    addDataColumnAuthOpeationBtnClick() {
      this.clearColunmForm();
      this.colunmOpterate = 0;
      this.currentOpreateObj = '';
      this.dataColumnAuthFormDisplayStatus = true;
    },
    editDataColumAuthBtnClickBtnClick(row) {
      this.dataColumnAuthValidate.funcMenuId = this.selectedMenuObj.id;
      this.dataColumnAuthValidate.ruleName = row.ruleName;
      this.dataColumnAuthValidate.ruleOrigJson = row.ruleOrigJson;
      this.dataColumnAuthValidate.tableName = row.tableName;
      this.currentOpreateObj = row;
      this.colunmOpterate = 1;
      this.dataColumnAuthFormDisplayStatus = true;
    },
    clearColunmForm() {
      this.dataColumnAuthValidate.ruleName = '';
      this.dataColumnAuthValidate.ruleOrigJson = '';
      this.dataColumnAuthValidate.tableName = '';
      // appId: '',
      // funcMenuId: '',
    },
    dataColumnSizeChange(size) {
      this.columnFilter = {
        pageIndex: 1,
        pageSize: size
      };
      this.getDataColumnAuthList({
        funcMenuId: this.selectedMenuObj.id,
        columnFilter: this.columnFilter
      });
    },
    refreshDataColumnAuthData() {
      this.columnFilter = {
        pageIndex: 1,
        pageSize: 10
      };
      this.getDataColumnAuthList({
        funcMenuId: this.selectedMenuObj.id,
        columnFilter: this.columnFilter
      });
    },
    deleteDataColumAuthBtnClick(row) {
      this.$Modal.confirm({
        title: '提示',
        content: '是否删除该菜单？',
        loading: true,
        cancelText: '取消',
        onOk: () => {
          this.$ajax.delete(`${addColunmRuleURL}/${row.id}`).then(res => {
            const { data } = res;
            this.$Modal.remove();
            if (data.code == 200) {
              this.$Message.success(data.msg);
              this.refreshDataColumnAuthData();
            } else {
              this.$Message.error(data.msg);
            }
          });
        }
      });
    },
    popDataRowMoal() {
      this.dataColumnAuthFormDisplayStatus = false;
    },
    dataColumnHandleSubmit(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.dataColumnAuthValidate.appId = this.currentSystem;
          this.dataColumnAuthValidate.funcMenuId = this.selectedMenuObj.id;
          const params = this.dataColumnAuthValidate;
          if (this.colunmOpterate == 0) {
            // 新增
            this.$ajax.post(addColunmRuleURL, params).then(res => {
              if (res.data.code == 200) {
                this.dataColumnAuthFormDisplayStatus = false;
                this.$Message.success(res.data.msg);
                this.refreshDataColumnAuthData();
              } else {
                this.$Message.error(res.data.msg);
              }
            });
          } else if (this.colunmOpterate == 1) {
            this.$ajax
              .put(`${addColunmRuleURL}/${this.currentOpreateObj.id}`, params)
              .then(res => {
                if (res.data.code == 200) {
                  this.dataColumnAuthFormDisplayStatus = false;
                  this.$Message.success(res.data.msg);
                  this.refreshDataColumnAuthData();
                } else {
                  this.$Message.error(res.data.msg);
                }
              });
          } else {
            console.log('no 0 no 1');
          }
        } else {
          this.$Message.error('所填信息异常');
        }
      });
    }
  }
};
</script>
<style></style>
